import { useNavigate } from 'react-router-dom'

import { routeName } from '~/@common/constants'
import { outerLinks } from '~/@common/constants/strings'
import { commonRepo } from '~/@common/services/repo.service'
import { colors } from '~/@common/styles'
import IconButton from '~/@common/ui/(Button)/IconButton/IconButton'
import { openLink } from '~/@common/utils/openLink'
import { mixpanelClient } from '~/@common/utils/trackings/mixpanel'

export const GuideVideoButton = () => {
  const navigate = useNavigate()
  return (
    <IconButton
      name="icon_help_line"
      title="사용가이드 보러가기"
      iconSize={26}
      iconStyle={{ color: colors.gray.$600 }}
      size={42}
      style={style}
      onClick={() => {
        if (commonRepo.isSchoolflat) {
          openLink(outerLinks.스쿨플랫_학생앱_사용_가이드_링크)
        } else {
          navigate(routeName.guideVideo)
        }
        mixpanelClient.track('GNB_사용가이드버튼_Click')
      }}
    />
  )
}

const style = {
  borderRadius: 'var(--Radius-200)',
  border: `1px solid ${colors.gray.$300}`,
}
